import React, { Component, Fragment } from 'react';

import FooterDesktop from '../components/common/FooterDesktop';
import FooterMobile from '../components/common/FooterMobile';
import NavMenuDesktop from '../components/common/NavMenuDesktop';
import NavMenuMobile from '../components/common/NavMenuMobile';
import LiveDemo from '../components/home/LiveDemo';
import NewsletterSubscribe from '../components/others/NewsletterSubscribe';
class LiveDemoPage extends Component {

  render() {

    return (

      <Fragment>

        {/* Desktop Navigation */}
        <div className="Desktop">
          <NavMenuDesktop />
        </div>

        {/* Mobile Navigation */}
        <div className="Mobile">
          <NavMenuMobile />
        </div>

        {/* Main Content */}
        <LiveDemo />
      <NewsletterSubscribe/>

        {/* Desktop Footer */}
        <div className="Desktop">
          <FooterDesktop />
        </div>

        {/* Mobile Footer */}
        <div className="Mobile">
          <FooterMobile />
        </div>

      </Fragment>

    );

  }

}

export default LiveDemoPage;